import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController } from '@ionic/angular';
import { OrderService } from './order.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  alert: HTMLIonAlertElement;
  constructor(public alertController: AlertController,
              private toastController: ToastController,
              private orderService: OrderService) {
               }

  async createAlertConfirm(){
    this.alert = await this.alertController.create({})
  }
  
  async presentAlertConfirm(order) {
    this.alert.header= 'Confirm!'
    this.alert.message= `Your order #${order.external_order_id} has been fulfilled!!!`
    this.alert.buttons= [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            setTimeout(() => {
              order.pickup_protocol.delivery_complete_acknowledged = {
                status: true,
                updated_at: new Date
              }
              this.orderService.orderPartialUpdate(order.id, order)
              console.log('updated delivery_complete_acknowledge.')
            }, 20 * 60 * 1000)
            console.log('update delivery_complete_acknowledge in 20mins');
          }
        }, {
          text: 'Confirm',
          handler: () => {
            order.pickup_protocol.delivery_complete_acknowledged = {
              status: true,
              updated_at: new Date
            }
            this.orderService.orderPartialUpdate(order.id, order)
            // this.presentToast('Info Updated');
          }
        }
      ]
      
    await this.alert.present();
  }

  async presentToast(err: string) {
    const toast = await this.toastController.create({
      message: err,
      duration: 2000
    });
    toast.present();
  }
}
